export default class Responsive {
    static MOBILE_WIDTH_MAX = 992;
}